import { gtmEvents } from './constants';
import { i18n } from './i18n';
import { IIndexSignature } from './types';

export const handleGtmErrors = (
  id?: number,
  data: IIndexSignature<string | number> = {}
) => {
  if (id && i18n.exists(`gtm-errors.${id}`) && (window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: gtmEvents.ERROR_MESSAGE,
      'error.id': id,
      'error.message': i18n.t(`gtm-errors.${id}`),
      ...data,
    });
  }
};
